import { ShieldSunIcon } from './ShieldSunIcon';

/**
 * author: Perth Totty
 * id 144E5B1F-A406-440D-B8B0-CC662F359D12
 * name shield-sun
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-sun.svg
 * tags
 * - Weather 
 */
export const SunProtectionIcon = ShieldSunIcon;
export default SunProtectionIcon